import type { Point } from './types';

/**
 * Computes the average distance from the center to all vertices.
 * Used for stable rendering scale across hex tiles.
 */
export function hexRadius(center: Point, verts: Point[]): number {
    let sum = 0;
    for (const v of verts) sum += Math.hypot(v.x - center.x, v.y - center.y);
    return sum / verts.length;
}
